module.exports = __webpack_public_path__ + "img/70_pourcent.0b1241fa.png";